import { useParams, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useEffect } from "react";

import { blue400 } from "../../../../shared/Helpers/colors";
import { CustomTable, Text } from "../../../../shared/uiComponents";
import { useCheckPermission } from "../../../../shared/Helpers/hooks";
import { AdminTypes } from "../../../../components/Menu";
import { TableBodyAll, TableBodyBCBA, headersAll } from "./tableInfo";
import AddInsuranceAuthorization from "./AddInsuranceAuthorization";
import { PERMISSIONS } from "../../../../App/constants";

import { DispatchProperties, useSelector } from "../../../../redux/store";
import {
  getActiveInsuranceAuthorizations,
  getInsuranceAuthorizations,
} from "../../../../redux/State/clientSlice/insuranceAuthorizationSlice";

const AdminPanel = () => {
  const dispatch = useDispatch<DispatchProperties>();
  const { clientId } = useParams();
  const [params] = useSearchParams();

  const userId = useSelector((state) => state.account.user.id);
  const loading = useSelector((state) => state.authorization.loading);
  const authorization = useSelector((state) => state.authorization.allInsuranceAuthorizations);
  const { permissionGranted } = useCheckPermission(PERMISSIONS.INSURANCE_AUTHORIZATION.CREATE);

  useEffect(() => {
    if (!clientId || !userId) return;
    const page = params.get("page") || "1";
    const pageSize = params.get("pageSize") || "8";

    dispatch(getInsuranceAuthorizations({ clientId, page, pageSize }));
  }, [clientId, dispatch, userId, params]);

  return (
    <>
      {permissionGranted && <AddInsuranceAuthorization />}
      <CustomTable
        TableBody={TableBodyAll}
        headers={headersAll}
        data={authorization}
        loading={loading}
      />
    </>
  );
};

const BCBAPanel = () => {
  const dispatch = useDispatch<DispatchProperties>();
  const { clientId } = useParams();

  const userId = useSelector((state) => state.account.user.id);
  const loading = useSelector((state) => state.authorization.loading);
  const authorization = useSelector(
    (state) => state.authorization.authorizationDetails
  );

  useEffect(() => {
    if (!clientId || !userId) return;
    dispatch(getActiveInsuranceAuthorizations({ clientId, userId }));
  }, [clientId, dispatch, userId]);

  return (
    <CustomTable
      TableBody={TableBodyBCBA}
      headers={headersAll}
      data={{ query: authorization }}
      loading={loading}
      hasPagination={false}
    />
  );
};

const InsuranceAuthorization = () => {
  const role = useSelector((state) => state.account.role);
  const { permissionGranted } = useCheckPermission(PERMISSIONS.INSURANCE_AUTHORIZATION.READ);

  const showAdminLayout = role?.section.id === AdminTypes.admin || role?.section.id === AdminTypes.cs;
  const showBCBALayout = role?.section.id === AdminTypes.bcba;

  if (!permissionGranted) return <Text title={"You do not have permission for this page"} />

  return (
    <div
      style={{
        border: `2px solid ${blue400}`,
        borderRadius: "12px",
        padding: "10px",
        marginTop: "10px",
      }}
    >
      {showAdminLayout && <AdminPanel />}
      {showBCBALayout && <BCBAPanel />}
    </div>
  );
};

export default InsuranceAuthorization;
